import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=10432a1d&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=10432a1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10432a1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10432a1d')) {
      api.createRecord('10432a1d', component.options)
    } else {
      api.reload('10432a1d', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=10432a1d&scoped=true&", function () {
      api.rerender('10432a1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21Yv1baC93sym/JS/comp/PopupDialog.vue"
export default component.exports